import script from "./ProductSeriesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductSeriesPage.vue?vue&type=script&setup=true&lang=js"

import "./ProductSeriesPage.vue?vue&type=style&index=0&id=869eceae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-869eceae"]])

export default __exports__